import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';
import eventsUserNoticesCollectionSaga from './sagas/eventsUserNoticesCollectionSaga';

export default [
  ...createCombineMapItem(
    'eventsUserNoticesCollection',
    createObjectCollectionReduceObject,
    [eventsUserNoticesCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/collections/reducersMap.js